module.exports = __webpack_public_path__ + "static/media/Golos_Text_Black.ae39af9a.ttf";